// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .templateLibraryContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 2rem;
}

.templateLibraryContainer_element {
} */

/* .cardContainer-Lib {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

.d-inline {
  display: inline !important;
}

.lib-imgWidth {
  width: 100%;
  margin: 0 auto;
}
.center-text {
  text-align: center;
}

.main-color {
  color: #f18f3c !important;
  font-weight: 600;
}

.libraryName {
  font-size: 1.2rem !important;
}

.labCard-Lib {
  background-color: #242424 !important;
  text-align: center;
  border-radius: 8px;
  padding: 20px 0;

  border-radius: 9px;
  width: 15vw;
  transition: 0.5s;
}
.labCard-Lib:hover {
  box-shadow: inset 5px 5px 8px rgb(49, 47, 47), inset -5px -5px 8px rgb(49, 47, 47);
  transform: translateY(-20px);
}
@media only screen and (max-width: 796px) {
  .labCard-Lib {
    width: 42vw;
    margin-left: 2rem;
    margin-bottom: 2rem;
  }
}
@media only screen and (max-width: 650px) {
  .labCard-Lib {
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
    width: 90vw;
  }
} */

.container-TL {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 1rem;
  margin: 0;
  padding: 0;
  color: #f6f3ea;
  transition: 0.5s;
}

.item-TL {
  padding: 1em;
  background-color: #272727 !important;
  text-align: center !important;
  height: fit-content;
  transition: 0.5s;
  min-height: 40vh;
}
.libraryName {
  font-size: 1.2rem !important;
}

.item-TL:hover {
  transform: scale(1.05);
  cursor: pointer;
  box-shadow: 0px 12px 30px 0px rgba(0, 0, 0, 0.2);
  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);
}

/* //// */
.boolean-input {
  display: inline-block;
  width: 30px !important;
}

.lib-imgWidth {
  width: 50%;
  margin: 0 auto;
}

/* ===================================================================== */

.centerMe {
  /* transform: translate(-50%, -50%); */
  /* margin-top: 3rem; */
  margin-top: 1rem !important;
  margin: 0 auto;
}

.button-del {
  display: flex;
  cursor: pointer;
  border: 0;
  background: transparent;
  outline: 0;
  overflow: hidden;
}
.button-del .icon {
  /* position: relative; */
  background: #1d242b;
  line-height: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  transition: 0.2s color;
  border-radius: 2px;
}
.button-del .icon .fa {
  width: 30px;
  transition: 0.2s all;
}
.button-del .icon .fa-check {
  color: #38b87c;
}
.button-del .icon .fa-question {
  color: #2492ff;
}
.button-del .icon:after {
  content: ' ';
  display: block;
  width: 0;
  height: 0;
  transform: rotate(45deg);
  background: #1d242b;
  transition: 0.2s right;
  z-index: 1;
}
.button-del .text {
  position: relative;
  width: 0;
  height: 30px;
  overflow: hidden;
  font-family: 'Roboto', sans-serif;
  background: #f34541;
  text-align: center;
  line-height: 30px;
  color: #fff;
  font-weight: 300;
  transition: 0.2s all;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.button-del .text span {
  width: 100%;
  opacity: 0;
  /* position: absolute;
  top: -30px;
  left: 50%; */
  transform: translateX(-50%);
  transition: 0.3s all;
}
.button-del:hover .icon {
  color: #f34541;
  border-radius: 0;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.button-del:hover .icon:after {
  right: -2px;
}
.button-del:hover .text {
  width: 120px;
}
.button-del:hover .text span {
  opacity: 1;
  top: 0;
}
.button-del.confirm .icon {
  border-radius: 0;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.button-del.confirm .icon .fa {
  transform: translateY(-30px);
}
.button-del.confirm .icon:after {
  right: -2px;
}
.button-del.confirm .text {
  background: #2492ff;
  width: 120px;
}
.button-del.confirm .text span {
  opacity: 1;
  top: 0;
}
.button-del.done .icon {
  border-radius: 0;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.button-del.done .icon .fa {
  transform: translateY(-60px);
}
.button-del.done .icon:after {
  right: -2px;
}
.button-del.done .text {
  background: #38b87c;
  width: 120px;
}
.button-del.done .text span {
  opacity: 1;
  top: 0;
}

@keyframes fadeInZoom {
  0% {
    opacity: 0;
    transform: scale(0.7);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.download-json-template:hover {
  border: 2px solid #272626 !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/private/components/systemcontrol/templateLibrary.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqDG;;AAEH;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA,0EAA0E;;AAE1E;EACE,sCAAsC;EACtC,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,UAAU;EACV;;cAEY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,MAAM;AACR;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;EACV,MAAM;AACR;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;EACV,MAAM;AACR;;AAaA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* .templateLibraryContainer {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: 2rem;\r\n}\r\n\r\n.templateLibraryContainer_element {\r\n} */\r\n\r\n/* .cardContainer-Lib {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n}\r\n\r\n.d-inline {\r\n  display: inline !important;\r\n}\r\n\r\n.lib-imgWidth {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n.center-text {\r\n  text-align: center;\r\n}\r\n\r\n.main-color {\r\n  color: #f18f3c !important;\r\n  font-weight: 600;\r\n}\r\n\r\n.libraryName {\r\n  font-size: 1.2rem !important;\r\n}\r\n\r\n.labCard-Lib {\r\n  background-color: #242424 !important;\r\n  text-align: center;\r\n  border-radius: 8px;\r\n  padding: 20px 0;\r\n\r\n  border-radius: 9px;\r\n  width: 15vw;\r\n  transition: 0.5s;\r\n}\r\n.labCard-Lib:hover {\r\n  box-shadow: inset 5px 5px 8px rgb(49, 47, 47), inset -5px -5px 8px rgb(49, 47, 47);\r\n  transform: translateY(-20px);\r\n}\r\n@media only screen and (max-width: 796px) {\r\n  .labCard-Lib {\r\n    width: 42vw;\r\n    margin-left: 2rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n}\r\n@media only screen and (max-width: 650px) {\r\n  .labCard-Lib {\r\n    margin-left: 0.5rem;\r\n    margin-bottom: 0.5rem;\r\n    width: 90vw;\r\n  }\r\n} */\r\n\r\n.container-TL {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  grid-gap: 1rem;\r\n  margin: 0;\r\n  padding: 0;\r\n  color: #f6f3ea;\r\n  transition: 0.5s;\r\n}\r\n\r\n.item-TL {\r\n  padding: 1em;\r\n  background-color: #272727 !important;\r\n  text-align: center !important;\r\n  height: fit-content;\r\n  transition: 0.5s;\r\n  min-height: 40vh;\r\n}\r\n.libraryName {\r\n  font-size: 1.2rem !important;\r\n}\r\n\r\n.item-TL:hover {\r\n  transform: scale(1.05);\r\n  cursor: pointer;\r\n  box-shadow: 0px 12px 30px 0px rgba(0, 0, 0, 0.2);\r\n  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);\r\n}\r\n\r\n/* //// */\r\n.boolean-input {\r\n  display: inline-block;\r\n  width: 30px !important;\r\n}\r\n\r\n.lib-imgWidth {\r\n  width: 50%;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* ===================================================================== */\r\n\r\n.centerMe {\r\n  /* transform: translate(-50%, -50%); */\r\n  /* margin-top: 3rem; */\r\n  margin-top: 1rem !important;\r\n  margin: 0 auto;\r\n}\r\n\r\n.button-del {\r\n  display: flex;\r\n  cursor: pointer;\r\n  border: 0;\r\n  background: transparent;\r\n  outline: 0;\r\n  overflow: hidden;\r\n}\r\n.button-del .icon {\r\n  /* position: relative; */\r\n  background: #1d242b;\r\n  line-height: 30px;\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  color: #fff;\r\n  font-size: 18px;\r\n  transition: 0.2s color;\r\n  border-radius: 2px;\r\n}\r\n.button-del .icon .fa {\r\n  width: 30px;\r\n  transition: 0.2s all;\r\n}\r\n.button-del .icon .fa-check {\r\n  color: #38b87c;\r\n}\r\n.button-del .icon .fa-question {\r\n  color: #2492ff;\r\n}\r\n.button-del .icon:after {\r\n  content: ' ';\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  transform: rotate(45deg);\r\n  background: #1d242b;\r\n  transition: 0.2s right;\r\n  z-index: 1;\r\n}\r\n.button-del .text {\r\n  position: relative;\r\n  width: 0;\r\n  height: 30px;\r\n  overflow: hidden;\r\n  font-family: 'Roboto', sans-serif;\r\n  background: #f34541;\r\n  text-align: center;\r\n  line-height: 30px;\r\n  color: #fff;\r\n  font-weight: 300;\r\n  transition: 0.2s all;\r\n  border-top-right-radius: 2px;\r\n  border-bottom-right-radius: 2px;\r\n}\r\n.button-del .text span {\r\n  width: 100%;\r\n  opacity: 0;\r\n  /* position: absolute;\r\n  top: -30px;\r\n  left: 50%; */\r\n  transform: translateX(-50%);\r\n  transition: 0.3s all;\r\n}\r\n.button-del:hover .icon {\r\n  color: #f34541;\r\n  border-radius: 0;\r\n  border-top-left-radius: 2px;\r\n  border-bottom-left-radius: 2px;\r\n}\r\n.button-del:hover .icon:after {\r\n  right: -2px;\r\n}\r\n.button-del:hover .text {\r\n  width: 120px;\r\n}\r\n.button-del:hover .text span {\r\n  opacity: 1;\r\n  top: 0;\r\n}\r\n.button-del.confirm .icon {\r\n  border-radius: 0;\r\n  border-top-left-radius: 2px;\r\n  border-bottom-left-radius: 2px;\r\n}\r\n.button-del.confirm .icon .fa {\r\n  transform: translateY(-30px);\r\n}\r\n.button-del.confirm .icon:after {\r\n  right: -2px;\r\n}\r\n.button-del.confirm .text {\r\n  background: #2492ff;\r\n  width: 120px;\r\n}\r\n.button-del.confirm .text span {\r\n  opacity: 1;\r\n  top: 0;\r\n}\r\n.button-del.done .icon {\r\n  border-radius: 0;\r\n  border-top-left-radius: 2px;\r\n  border-bottom-left-radius: 2px;\r\n}\r\n.button-del.done .icon .fa {\r\n  transform: translateY(-60px);\r\n}\r\n.button-del.done .icon:after {\r\n  right: -2px;\r\n}\r\n.button-del.done .text {\r\n  background: #38b87c;\r\n  width: 120px;\r\n}\r\n.button-del.done .text span {\r\n  opacity: 1;\r\n  top: 0;\r\n}\r\n\r\n@-webkit-keyframes fadeInZoom {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.7);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes fadeInZoom {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.7);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.download-json-template:hover {\r\n  border: 2px solid #272626 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
